import React, { useState } from "react";
import { RefreshCw, SlidersHorizontal, ChevronDown } from "lucide-react";
import { Input } from "../../../components/ui/Field";

/**
 * Toolbar for Dispatch History: title, refresh, and a date-range filter.
 * Mirrors BatchToolbar's layout/spacing/button styling so the two modules
 * read as the same product, minus the Add/Export actions that don't apply
 * to a read-only history view.
 */
const DispatchHistoryToolbar = ({ dateFrom, dateTo, onDateFromChange, onDateToChange, onClearDates, onRefresh, isRefreshing }) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const hasDateFilter = Boolean(dateFrom || dateTo);

  return (
    <div className="flex flex-col gap-3 pb-4 sm:flex-row sm:items-center sm:justify-between">
      <h1 className="text-2xl font-semibold text-slate-900">Dispatch History</h1>

      <div className="flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
        <button
          type="button"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-3.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <RefreshCw className={`h-4 w-4 ${isRefreshing ? "animate-spin" : ""}`} />
          Refresh
        </button>

        <div className="relative">
          <button
            type="button"
            onClick={() => setFilterOpen((open) => !open)}
            className="inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-3.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-50"
          >
            <SlidersHorizontal className="h-4 w-4" />
            Filter
            {hasDateFilter && <span className="h-1.5 w-1.5 rounded-full bg-brand" />}
            <ChevronDown className="h-3.5 w-3.5" />
          </button>
          {filterOpen && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setFilterOpen(false)} />
              <div className="absolute right-0 top-full z-20 mt-2 w-64 rounded-lg border border-slate-200 bg-white p-3 shadow-xl">
                <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Dispatched On</p>
                <div className="space-y-2">
                  <div>
                    <label className="mb-1 block text-xs text-slate-500">From</label>
                    <Input type="date" value={dateFrom} onChange={(event) => onDateFromChange(event.target.value)} />
                  </div>
                  <div>
                    <label className="mb-1 block text-xs text-slate-500">To</label>
                    <Input type="date" value={dateTo} onChange={(event) => onDateToChange(event.target.value)} />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={onClearDates}
                  className="mt-3 text-xs font-medium text-brand hover:underline"
                >
                  Clear dates
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DispatchHistoryToolbar;
